import { useEffect, useState } from 'react';
import { useForm, yupResolver, } from '@mantine/form';
import { TextInput, Modal, Text, Center, Button, Code, SimpleGrid, NumberInput } from '@mantine/core';

import useGetSubscription from './useGetSubscription';
import useEdit from './useEdit';
import { useDisclosure } from '@mantine/hooks';
import { object, number, string } from "yup";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';

const userSchema = object().shape({
    name: string()
        .required("Name is required")
        .max(255, "Name is too long"),
    amount: number()
        .required("IOS Amount is required"),
    android_amount: number()
        .required("Android Amount is required"),



});
function Demo() {
    const [opened, { open, close }] = useDisclosure(false);
    const {
        editMutation
    } = useEdit()


    const { data, isPending } = useGetSubscription();

    useEffect(() => {
        if (!isPending && data) {
            let nameLocal = {}
            for (const key in data?.name_local) {
                nameLocal = {
                    ...nameLocal,
                    ["name_" + key]: data?.name_local[key] === "null" || data?.name_local[key] === "undefined" ? null : data?.name_local[key],

                }
            }
            form?.setValues({
                ...data,
                ...nameLocal,
            })
        }
    }, [data, isPending]);

    const [submittedValues] = useState('');

    const form = useForm({
        // mode: 'uncontrolled',
        initialValues: {
            id: "", amount: "", name: "", android_amount: "",


        },
        validate: yupResolver(userSchema)
    });



    const handleEdit = form.onSubmit(async (values) => {

        const formData = new FormData();
        formData.append("id", values?.id);
        formData.append("name", values?.name);
        formData.append("amount", values?.amount);
        formData.append("android_amount", values?.android_amount);
        values?.name_de == null || formData.append("name_de", values?.name_de);
        values?.name_it == null || formData.append("name_it", values?.name_it);
        values?.name_fr == null || formData.append("name_fr", values?.name_fr);
        values?.name_es == null || formData.append("name_es", values?.name_es);
        values?.name_pt == null || formData.append("name_pt", values?.name_pt);
        values?.name_nl == null || formData.append("name_nl", values?.name_nl);
        values?.name_ar == null || formData.append("name_ar", values?.name_ar);
        editMutation.mutate(formData)
    })
    console.log(form.values);
    return (
        <LoadingErrorContainer isLoading={isPending}>
            <h1>Edit Subscription Amount</h1>

            <SimpleGrid cols={2}>
                <TextInput
                    label="Name English"
                    placeholder="Enter Name"
                    key={form.key('name')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name')}
                />

                <TextInput
                    label="Name French"
                    placeholder="Enter Name"
                    key={form.key('name_fr')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_fr')}
                />
                <TextInput
                    label="Name Italian"
                    placeholder="Enter Name"
                    key={form.key('name_it')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_it')}
                />

                <TextInput
                    label="Name Spanish"
                    placeholder="Enter Name"
                    key={form.key('name_es')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_es')}
                />
                <TextInput
                    label="Name German"
                    placeholder="Enter Name"
                    key={form.key('name_de')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_de')}
                />

                <TextInput
                    label="Name Portuguese"
                    placeholder="Enter Name"
                    key={form.key('name_pt')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_pt')}
                />

                <TextInput
                    label="Name Dutch"
                    placeholder="Enter Name"
                    key={form.key('name_nl')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_nl')}
                />
                <TextInput
                    label="Name Arabic"
                    placeholder="Enter Name"
                    key={form.key('name_ar')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name_ar')}
                />
                <TextInput
                    label="Months"
                    placeholder="Enter Months"
                    key={form.key('type')}
                    Limit={{ alignSelf: "baseline" }}
                    {...form.getInputProps('months')}
                    disabled
                />

                <NumberInput
                    label="IOS Amount"
                    placeholder="Enter Amount"
                    key={form.key('amount')}
                    Limit={{ alignSelf: "baseline" }}
                    {...form.getInputProps('amount')}

                />
                <NumberInput
                    label="Android Amount"
                    placeholder="Enter Android Amount"
                    key={form.key('android_amount')}
                    Limit={{ alignSelf: "baseline" }}
                    {...form.getInputProps('android_amount')}

                />


                <br></br>
                <div />
            </SimpleGrid>
            <Button type="submit" mt="md" onClick={handleEdit} loading={editMutation?.isPending}>
                Submit
            </Button>
            &nbsp;
            <Button type="button" mt="md" color="red" onClick={open} >
                Return
            </Button>

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page without saving?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >
            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </LoadingErrorContainer>
    );
}



export default Demo;
